
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import $$ from 'dom7';
import * as moment from 'moment';
import Framework7 from 'framework7/framework7.esm.bundle.js';
export default {
  // Component Data
  data: function () {
    let entries = [];
    // Must return an object
    let entryDict = categorizeEntries(entries);
    let newEntries = formatEntries(entryDict);
    return {
      entries,
      entryDict,
      items: newEntries,
      allowInfinite: true,
      hasMoreItems: true,
      lastItem: 20
    };
  },
  methods: {
    loadEntries: function () {
      let self = this;
      if (!self.$app.authPromise) {
        return;
      }
      self.$app.authPromise.then(() => {
        db.collection('entries').where('userId', '==', self.$app.data.user.uid).get().then(function (querySnapshot) {
          self.entries = [];
          querySnapshot.forEach(function (doc) {
            let entry = doc.data();
            entry.uid = doc.id;
            self.entries.push(entry);
          });
          self.$app.data.entries = self.entries;
          // sort entries
          self.entries.sort((a, b) => {
            return a.date > b.date ? -1 : 1;
          });
          self.entryDict = categorizeEntries(self.entries);
          self.items = formatEntries(self.entryDict);
          self.$setState();

          // Hide infinite scroll preloader since we load all entries at once
          self.$$('.infinite-scroll-preloader').hide();
        }).catch(err => {
          console.error('Error loading entries:', err);
          // Hide preloader on error too
          self.$$('.infinite-scroll-preloader').hide();
        });
      }).catch(() => {
        // User not authenticated, login screen will be shown
      });
    },
    loadMore: function () {
      var self = this;
    }
  },
  on: {
    pageBeforeIn: function (e, page) {
      let self = this;

      // Wait for authPromise to be ready before loading entries
      if (self.$app.authPromise) {
        self.loadEntries();
      } else {
        // If authPromise isn't ready yet, wait for it
        const checkAuth = () => {
          if (self.$app.authPromise) {
            self.loadEntries();
          } else {
            setTimeout(checkAuth, 100);
          }
        };
        checkAuth();
      }
      self.$app.on('logged-in', function () {
        self.loadEntries();

        // Check if this is first time user and show welcome
        setTimeout(() => {
          if (self.$app.data.settings && !self.$app.data.settings.hasSeenWelcome) {
            self.$f7router.navigate('/welcome/');
          }
        }, 500);
      });
    }
  },
  id: '507768f359',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=home><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=title>Mindfulness Journal</div></div></div><!-- Scrollable page content--><div class="page-content infinite-scroll-content" @infinite=loadMore><!-- List of entries --><div class="list media-list chevron-center"><div class=list-group><ul>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.items, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=list-group-title>';
          r += c(ctx_2.monthYear, ctx_2);
          r += '</li>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.monthEntries, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<li><a href="/entry/';
              r += c(ctx_3.date, ctx_3);
              r += '/?uid=';
              r += c(ctx_3.uid, ctx_3);
              r += '" class="item-link item-content"><div class=item-media><i class="icon f7-icons if-not-md">';
              r += Template7Helpers.if.call(ctx_3, ctx_3.bookmark, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'bookmark_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i> <i class="icon material-icons if-md">';
              r += Template7Helpers.if.call(ctx_3, ctx_3.bookmark, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'bookmark';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i></div><div class=item-inner><div class=item-title-row><div class=item-title>';
              r += c(ctx_3.title, ctx_3);
              r += '</div><div class=item-after><span class=badge>';
              r += c(ctx_3.daysSober, ctx_3);
              r += '</span>&nbsp; <span class="badge ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.green, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'color-green';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '">';
              r += c(ctx_3.points, ctx_3);
              r += '</span></div></div><div class=item-text>';
              r += c(ctx_3.sobriety, ctx_3);
              r += '</div></div></a></li>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div></div><div class="preloader infinite-scroll-preloader"></div></div><!-- Floating Action Button --> <a href=/entry/new/ class="link fab fab-center-bottom" data-animate=true><span class=fab-icon>+</span></a></div>';
      return r;
    }(this);
  },
  style: `
  .page[data-name="home"] .navbar-inner {
    justify-content: center;
  }
  .page[data-name="home"] .title {
    text-align: center;
  }
  .list {
    margin: 0;
  }
  .fab-center-bottom {
    position: fixed !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    bottom: 20px !important;
    z-index: 9999 !important;
    width: 56px !important;
    height: 56px !important;
    background: var(--f7-theme-color) !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: 0 4px 8px rgba(0,0,0,0.3) !important;
  }
  .fab-icon {
    font-size: 32px !important;
    color: white !important;
    line-height: 1 !important;
    font-weight: 300 !important;
  }
`,
  styleScoped: false
};
function categorizeEntries(entries) {
  let newEntries = {};
  entries.forEach(entry => {
    let m = moment(entry.date);
    let key = m.format('MMMM YYYY');
    if (!(key in newEntries)) {
      newEntries[key] = [];
    }
    newEntries[key].push({
      uid: entry.uid,
      date: entry.date,
      title: m.format('D - dddd'),
      points: entry.points,
      bookmark: entry.bookmark,
      sobriety: entry.sobriety,
      daysSober: entry.daysSober,
      green: entry.points > 18
    });
  });
  return newEntries;
}
function formatEntries(newEntries) {
  let newNewEntries = [];
  Object.keys(newEntries).forEach(key => {
    newNewEntries.push({
      monthYear: key,
      monthEntries: newEntries[key]
    });
  });
  return newNewEntries;
}
    